import styled from 'styled-components'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'

export const ExplicitHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 12px 14px;
`

export const ExplicitHeaderTextContainer = styled.div`
  max-width: 132px;
  margin-left: 8px;

  h5 {
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.neutralW100};
  }

  p {
    font-size: 10px;
    color: ${({ theme }) => theme.colors.neutralW70};
  }
`

export const ToggleWrapper = styled.div`
  padding-top: 2px;
  input {
    &:checked + label {
      background: ${({ theme }) => theme.colors.interact70}!important;
      &::after {
        width: 9.75px !important;
        height: 9.75px !important;
        margin-left: 11px !important;
      }
    }
  }

  label {
    background: ${({ theme }) => theme.colors.neutralW40}!important;
    &::after {
      width: 9.75px;
      height: 9.75px;
    }
  }
`
export const FilterWrapper = styled.div`
  display: flex;
  margin-top: ${({ $isMobile }) => ($isMobile ? '16px' : 0)};
  gap: 8px;
  flex-wrap: wrap;
`

export const StyledDropdownMenuSubContent = styled(DropdownMenu.SubContent)`
  background: ${({ theme }) => theme.colors.neutralW20};
  color: ${({ theme }) => theme.colors.neutralW100};
  padding: 5px 0;
  height: auto;
  max-height: 216px;
  overflow: auto;
  border: 0.5px solid ${({ theme }) => theme.colors.neutralW30};
  z-index: 1000;
`
